import EnterID from './EnterID.jsx';

export default EnterID;